import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBalloon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBalloon"><Path d="M12 20C15.1875 20 20.5 16.1912 20.5 9.69286C20.5 4.58422 16.6944 1.5 12 1.5C7.30558 1.5 3.5 4.58422 3.5 9.69286C3.5 16.1912 8.8125 20 12 20Z" stroke="currentColor" strokeLinecap="round"/><Path d="M6.5 10.0357C6.5 6.58394 8.96243 4.5 12 4.5" stroke="currentColor"/><Path d="M13.5 20L14.6562 22.5H9.5L10.5 20" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBalloon;
